/**
 * Shared input styling for the catalog editors.
 *
 * Identifiers with a strict format (cycle key, custom-field internal name,
 * ISO dates) render monospaced; names and labels — text a human wrote for
 * another human — do not. The distinction is informational, not decorative.
 */
const BASE =
  "min-w-0 rounded-md border px-2.5 py-1.5 text-[13.5px] text-ink-900 placeholder:text-ink-300 focus:border-moss focus:outline-none disabled:bg-ink-050 disabled:text-ink-300";

export function fieldClass(opts?: { mono?: boolean; invalid?: boolean }): string {
  const border = opts?.invalid ? "border-red-400 bg-red-50/40" : "border-ink-200 bg-white";
  const font = opts?.mono ? "font-mono text-[12.5px]" : "";
  return `${BASE} ${border} ${font}`.trim();
}
